import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";
import { integrationsCollection } from "@/config/firebase";
import { roles, integrations } from "@/helpers/get_constants";

export default {
  async getAllIntegrations({ commit }) {
    let snap = await integrationsCollection.get();
    if (!snap.empty)
      snap.forEach((doc) => {
        commit(MutationsType[`SET_INTEGRATION_${doc.id.toUpperCase()}`], { ...doc.data(), id: doc.id });
      });
  },
  async getIntegrationById({ commit }, payload) {
    let doc = await integrationsCollection.doc(payload.id).get();
    let config = doc.exists ? { id: doc.id, ...doc.data() } : null;

    commit(MutationsType.SET_INTEGRATION_CONFIG, config);
  },
  async saveIntegration({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration",
        method: "POST",
        data: payload,
      });
      commit(MutationsType[`SET_INTEGRATION_${payload.id.toUpperCase()}`], { ...response.data.data, id: payload.id });
      return response.data;
    } catch (error) {
      console.error("saveIntegration: ", error);
      throw error.response.data;
    }
  },
  async updateIntegration({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/integration/${payload.id}`,
        method: "PUT",
        data: payload.data,
      });
      commit(MutationsType[`SET_INTEGRATION_${payload.id.toUpperCase()}`], { ...response.data.data, id: payload.id });
      return response.data;
    } catch (error) {
      console.error("updateIntegration: ", error);
      throw error.response.data;
    }
  },
  async removeIntegration({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/integration/${payload.id}`,
        method: "DELETE",
      });
      commit(MutationsType[`SET_INTEGRATION_${payload.id.toUpperCase()}`], null);
      return response.data;
    } catch (error) {
      console.error("removeIntegration: ", error);
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async verifyIntegrationZoomWebinars({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/zoomwebinars/verify-account",
        method: "POST",
        data: payload,
      });
      return response.data;
    } catch (error) {
      console.error("verifyIntegrationZoomWebinars: ", error);
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async registerUsersToZoomWebinar({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/zoomwebinars/register-attendees",
        method: "POST",
        data: payload,
      });
      return response.data;
    } catch (error) {
      console.error("registerUsersToZoomWebinar: ", error);
      throw error.response.data;
    }
  },
  async saveSendGridConfig({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/sendgrid/config",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.SET_INTEGRATION_SENDGRID, response.data.data);
      return response.data;
    } catch (error) {
      console.error("saveSendGridConfig: ", error);
      throw error.response.data;
    }
  },
  async getSendGridConfig({ commit, rootState }) {
    const agent = rootState.Agent.agent;
    let reference = integrationsCollection.doc(integrations.SENDGRID);

    if (agent.role === roles.ENTREPRENEUR) reference = reference.collection("integrated_teams").doc(agent.team_id);

    const doc = await reference.get();
    commit(MutationsType.SET_INTEGRATION_SENDGRID, doc.exists ? { id: doc.id, ...doc.data() } : null);
  },
  // eslint-disable-next-line
  async verifySendGridSendMail({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/sendgrid/verify-send-mail",
        method: "POST",
        data: payload,
      });
      return response.data;
    } catch (error) {
      console.error("verifySendGridSendMail: ", error);
      throw error.response.data;
    }
  },
  async saveSendGridConfigSendMail({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/sendgrid/config-send-mail",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.UPDATE_INTEGRATION_SENDGRID, response.data.data);
      return response.data;
    } catch (error) {
      console.error("saveSendGridConfigSendMail: ", error);
      throw error.response.data;
    }
  },
  async saveSendGridConfigInboundParse({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/sendgrid/config-inbound-parse",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.UPDATE_INTEGRATION_SENDGRID, response.data.data);
      return response.data;
    } catch (error) {
      console.error("saveSendGridConfigInboundParse: ", error);
      throw error.response.data;
    }
  },
  async removeSendGridConfig({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/sendgrid/config",
        method: "DELETE",
        data: payload,
      });
      commit(MutationsType["SET_INTEGRATION_SENDGRID"], response.data.data);
      return response.data;
    } catch (error) {
      console.error("removeSendGridConfig: ", error);
      throw error.response.data;
    }
  },
  async getWhatsAppConfig({ commit, rootState }) {
    const unsubscribe = await integrationsCollection
      .doc(integrations.WHATSAPP)
      .collection("integrated_agents")
      .doc(rootState.Agent.agent.uid)
      .onSnapshot(async (doc) => {
        commit(
          MutationsType.SET_INTEGRATION_WHATSAPP,
          doc.exists
            ? {
                ...doc.data(),
                id: "whatsapp",
              }
            : null,
        );
      });

    commit(MutationsType.UNSUBSCRIBE_GET_INTEGRATION_WHATSAPP, unsubscribe);
  },
  async unsubscribeGetWhatsAppConfig({ commit, state }) {
    state.unsubscribeIntegrationWhatsApp();
    commit(MutationsType.SET_INTEGRATION_WHATSAPP, null);
    commit(MutationsType.UNSUBSCRIBE_GET_INTEGRATION_WHATSAPP, null);
  },
  // eslint-disable-next-line
  async generateAuthQRWhatsApp({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/whatsapp/generate-auth-qr",
        method: "POST",
      });
      return response.data;
    } catch (error) {
      console.error("generateAuthQRWhatsApp: ", error);
      throw error.response.data;
    }
  },
  async removeWhatsAppConfig({ rootState, commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/whatsapp/config",
        method: "DELETE",
        data: { agent_id: rootState.Agent.agent.uid },
      });
      commit(MutationsType["SET_INTEGRATION_WHATSAPP"], null);
      return response.data;
    } catch (error) {
      console.error("removeWhatsAppConfig: ", error);
      throw error.response.data;
    }
  },
  async getFBCatalogConfig({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/facebook/catalog",
        method: "GET",
      });
      commit(MutationsType.SET_INTEGRATION_FB_CATALOG, { ...response.data.data, id: integrations.FB_CATALOG });
      return response.data;
    } catch (error) {
      console.error("getFBCatalogConfig: ", error);
      throw error.response.data;
    }
  },
  async saveFBCatalogConfig({ commit, state }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/facebook/catalog",
        method: "POST",
        data: state.integrationFbCatalog,
      });
      commit(MutationsType.SET_INTEGRATION_FB_CATALOG, { ...response.data.data, id: integrations.FB_CATALOG });
      return response.data;
    } catch (error) {
      console.error("saveFBCatalogConfig: ", error);
      throw error.response.data;
    }
  },
  async removeFBCatalogConfig({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/integration/facebook/catalog",
        method: "DELETE",
      });
      commit(MutationsType.SET_INTEGRATION_FB_CATALOG, null);
      return response.data;
    } catch (error) {
      console.error("saveFBCatalogConfig: ", error);
      throw error.response.data;
    }
  },
};
